var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgDrag = function SvgDrag(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65918 7.99935C5.65918 7.26297 6.25863 6.66602 6.99809 6.66602C7.73756 6.66602 8.33701 7.26297 8.33701 7.99935C8.33701 8.73573 7.73756 9.33268 6.99809 9.33268C6.25863 9.33268 5.65918 8.73573 5.65918 7.99935Z",
    fill: "#636669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67578 7.99935C9.67578 7.26297 10.2752 6.66602 11.0147 6.66602C11.7542 6.66602 12.3536 7.26297 12.3536 7.99935C12.3536 8.73573 11.7542 9.33268 11.0147 9.33268C10.2752 9.33268 9.67578 8.73573 9.67578 7.99935Z",
    fill: "#636669"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65918 3.33333C5.65918 2.59695 6.25863 2 6.99809 2C7.73756 2 8.33701 2.59695 8.33701 3.33333C8.33701 4.06971 7.73756 4.66667 6.99809 4.66667C6.25863 4.66667 5.65918 4.06971 5.65918 3.33333Z",
    fill: "#636669"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67578 3.33333C9.67578 2.59695 10.2752 2 11.0147 2C11.7542 2 12.3536 2.59695 12.3536 3.33333C12.3536 4.06971 11.7542 4.66667 11.0147 4.66667C10.2752 4.66667 9.67578 4.06971 9.67578 3.33333Z",
    fill: "#636669"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65918 12.6673C5.65918 11.9309 6.25863 11.334 6.99809 11.334C7.73756 11.334 8.33701 11.9309 8.33701 12.6673C8.33701 13.4037 7.73756 14.0007 6.99809 14.0007C6.25863 14.0007 5.65918 13.4037 5.65918 12.6673Z",
    fill: "#636669"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67578 12.6673C9.67578 11.9309 10.2752 11.334 11.0147 11.334C11.7542 11.334 12.3536 11.9309 12.3536 12.6673C12.3536 13.4037 11.7542 14.0007 11.0147 14.0007C10.2752 14.0007 9.67578 13.4037 9.67578 12.6673Z",
    fill: "#636669"
  })));
};
export default SvgDrag;